export default {
  title: 'Revisão de Dados',
  subtitle: 'Veja em gráficos os dados do seu Data Template aprovado antes de começar a modelagem. Procure períodos faltantes, picos repentinos e séries que não batem com o que você sabe do seu negócio.',
  uploadedBy: 'enviado por {name} em {date}',
  templateApprovedBy: 'aprovado por {name} em {date}',
  statusPending: 'Revisão pendente',
  statusApproved: 'Aprovada',
  validationWarnings: 'Este template foi aprovado com {count} aviso de validação. | Este template foi aprovado com {count} avisos de validação.',
  viewInDataUpload: 'Ver em Upload de Dados',

  // States
  noTemplateTitle: 'Ainda não há um Data Template aprovado',
  noTemplateText: 'Envie seu Data Template e aprove-o em Upload de Dados; depois volte aqui para revisá-lo.',
  goToDataUpload: 'Ir para Upload de Dados',
  loadingTitle: 'Preparando seus dados…',
  loadingText: 'Estamos lendo seu template e somando cada série.',
  loadingSlowText: 'Templates grandes podem levar alguns minutos. Você pode deixar esta página aberta.',
  errorTitle: 'Não conseguimos preparar seus dados',
  errorText: 'Tente novamente. Se continuar falhando, fale com a nossa equipe.',
  errorPermission: 'Você não tem acesso à Revisão de Dados deste modelo.',
  errorNotApproved: 'O Data Template não está mais aprovado. Aprove-o primeiro em Upload de Dados.',
  errorDisabled: 'O upload de dados não está habilitado para este modelo.',
  retry: 'Tentar novamente',

  // Tiles
  tileDateRange: 'Período total',
  tileFrequency: 'Frequência das vendas',
  tileSeries: 'Séries',
  tileSheetsWithData: 'Abas com dados',
  tileSheetsOf: '{count} de {total}',
  tileFlagged: 'Séries a revisar',
  tileNone: 'Nenhuma',
  frequencyDaily: 'Diária',
  frequencyWeekly: 'Semanal',
  frequencyMonthly: 'Mensal',
  frequencyQuarterly: 'Trimestral',
  frequencyYearly: 'Anual',
  frequencyIrregular: 'Irregular',

  // Sheet groups
  groupKpi: 'Vendas e KPIs',
  groupOwn: 'Marketing próprio',
  groupCompetition: 'Concorrência',
  groupContext: 'Mercado e contexto',
  groupSpecialDates: 'Datas especiais',
  specialDatesEmpty: 'Este template não tem datas especiais',
  eventsHeaderStart: 'Início',
  eventsHeaderEnd: 'Fim',
  eventsHeaderEvent: 'Evento',
  eventsHeaderDescription: 'Descrição',
  eventsTruncated: 'Só as primeiras 500 datas especiais são listadas.',

  // Approval
  approvalTitle: 'Aprovar a Revisão de Dados',
  approvalText: 'Quando os gráficos estiverem certos, aprove a Revisão de Dados. Nossa equipe será avisada e seguirá com o modelo.',
  approvalCheckbox: 'Revisei os gráficos e os dados estão corretos',
  approveButton: 'Aprovar Revisão de Dados',
  approvedTitle: 'Revisão de Dados aprovada',
  approvedText: 'Aprovada por {name} em {date}. Nossa equipe já foi avisada.',
  markAsPending: 'Voltar para pendente',
  approvedSnackbar: 'Revisão de Dados aprovada. Nossa equipe já foi avisada.',
  pendingSnackbar: 'A Revisão de Dados voltou para pendente.',
  approvalError: 'Não foi possível atualizar a Revisão de Dados. Tente novamente.',

  // Footer
  generatedAt: 'Gráficos preparados em {date}',
  partialNotice: 'Alguns detalhes ficaram de fora para a página carregar rápido.'
}
